import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from 'i2g-ng-utils';

export const SCHEMA = Object.freeze({
  EMAIL: '',
  USER_ID: '',
});

const RECORD = generateSchema(SCHEMA);
const KEYS: any = generateKeys(SCHEMA);

export class SetToken extends Record(RECORD) {
  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get email(): string {
    return this.get(KEYS.EMAIL);
  }

  get userId(): string {
    return this.get(KEYS.USER_ID);
  }
}
